/*
 * Module for the topic publish modal
 */

define([
  "marionette",
  "backbone",
  "messaging/messenger",
  "underscore",
  "modules/topicsSplit/topic/topicPublishModal/topicPublishModalView",
  "modules/shared/treeList/treeListModule",
  "modules/shared/treeList/treeListModel",
  "modules/header/kbMenu/kbMenuModel",
  "modules/topicsSplit/topic/topicResponse/topicResponseModel",
], function (
  Marionette,
  Backbone,
  Messenger,
  _,
  TopicPublishModalView,
  TreeListModule,
  TreeListModel,
  KbMenuModel,
) {
  "use strict";

  var TopicPublishModalController = Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.name = "topicPublishModal";
      this.namespace = options.namespace;
      this.namespacePrefix = this.namespace ? this.namespace + ":" : "";
    },
    show: function (topic) {
      this.touchPoints = Messenger.reqres.request("kb:touchpoints");
      this.locales = Messenger.reqres.request("kb:languages");
      this.layout = new TopicPublishModalView.topicPublishModalLayout();
      this.root = this._buildModel(topic, this.touchPoints, this.locales);
      this.pendingResponsesList = this.addSubModule(
        new TreeListModule({
          region: this.layout.pendingResponseList,
          namespace: this.name,
        }),
      );

      this.layout.on(
        "done",
        function () {
          this.layout.hideError();
          var selectedResponses = Messenger.reqres.request(this.name + ":treeList:selected:nodes");
          if (selectedResponses.length === 0) {
            this.layout.hideWarning();
            //no pending responses selected
            this.layout.showError();
          } else {
            topic.conversation().selectedResponses = selectedResponses;
            Messenger.vent.trigger("close:modal");
            Messenger.vent.trigger(this.namespacePrefix + "publish:pending:responses");
          }
        },
        this,
      );
      this.layout.on(
        "cancel",
        function () {
          this.layout.hideError();
          Messenger.vent.trigger("close:modal");
          Messenger.vent.trigger(this.namespacePrefix + "cancel:pending:responses");
        },
        this,
      );
      this.layout.on(
        "selectAll",
        function () {
          Messenger.vent.trigger(this.name + ":treeList:select:all");
        },
        this,
      );
      this.layout.on(
        "deselectAll",
        function () {
          Messenger.vent.trigger(this.name + ":treeList:deselect:all");
        },
        this,
      );
      this.layout.on(
        "show",
        function () {
          this.layout.hideError();
          this._showSubViews();
        },
        this,
      );

      this.showRegion(this.layout);

      //display warning message if topic was previously disabled
      if (topic.getStatus() === KbMenuModel.statuses.VERSIONED_DISABLED) {
        this.layout.showWarning();
      } else {
        this.layout.hideWarning();
      }
    },
    _buildModel: function (topic, touchPoints, locales) {
      var pendingResponseTemplates = [];
      this._findPendingResponseTemplates(topic.conversation(), pendingResponseTemplates);
      this.treeData = [];
      locales.forEach(function (locale) {
        var node = {
          name: locale.get("name"),
          data: locale.get("id"),
          nodes: [],
        };
        var languageId = locale.get("id");
        touchPoints.forEach(
          function (touchPoint) {
            var pendingResponseTemplate;
            var touchPointId;
            if (pendingResponseTemplates) {
              touchPointId = touchPoint.get("touchPointId");
              pendingResponseTemplate = _.find(pendingResponseTemplates, function (r) {
                return r.get("touchpointId") == touchPointId && r.get("languageId") == languageId;
              });
            }
            if (pendingResponseTemplate) {
              this.nodes.push({
                name: touchPoint.get("touchPoint"),
                data: languageId + "_" + touchPointId,
              });
            }
          },
          { nodes: node.nodes },
        );
        if (node.nodes.length > 0) {
          this.treeData.push(node);
        }
      }, this);
      return new TreeListModel.collection(this.treeData);
    },
    _findPendingResponseTemplates: function (conversationModel, pendingResponseTemplates) {
      var responseTemplates = conversationModel.responseTemplates();
      var result = responseTemplates.each(function (responseTemplate) {
        if (
          responseTemplate.get("statusId") != KbMenuModel.statuses.VERSIONED_PUBLISHED &&
          !responseTemplate.isNew()
        ) {
          pendingResponseTemplates.push(responseTemplate);
        }
      }, this);
      var decisions = conversationModel.decisionCol;
      if (decisions && decisions.length > 0) {
        decisions.each(function (decision) {
          this._findPendingResponseTemplates(decision, pendingResponseTemplates);
        }, this);
      }
      return result;
    },
    _showSubViews: function () {
      this.pendingResponsesList.show({ model: this.root });
    },
  });

  return TopicPublishModalController;
});
